export class EnaioWorkflowActivityApplication {
    id = "";
    actualParameters: string[];
}
